import React from "react";
import { OrderHeaderSection } from './widgets/OrderHeaderSection';
import { ItemsSection } from './widgets/ItemsSection';
import { TotalsSection } from './widgets/TotalsSection';
import { DiscountsSection } from './widgets/DiscountsSection';
import { StatusSummarySection } from './widgets/StatusSummarySection';
import { CustomerSection } from './widgets/CustomerSection';
import { BillingAddressSection, ShippingAddressSection } from './widgets/AddressSection';
import { CurrencyPriceListSection } from './widgets/CurrencyPriceListSection';
import { SalesTeamSection } from './widgets/SalesTeamSection';
import { GenericSection } from './widgets/GenericSection';
import type { ShopifySectionWidgetProps } from './types';

// Export all widgets
export {
  OrderHeaderSection,
  ItemsSection,
  TotalsSection,
  DiscountsSection,
  StatusSummarySection,
  CustomerSection,
  BillingAddressSection,
  ShippingAddressSection,
  CurrencyPriceListSection,
  SalesTeamSection,
  GenericSection,
};

// Export widget map (deterministic, explicit)
// Note: Using wrapper components instead of inline lambdas for clean component identity
export const SALES_ORDER_WIDGETS: Record<string, React.ComponentType<ShopifySectionWidgetProps>> = {
  "order-overview": OrderHeaderSection,
  "customer-channel": CustomerSection,
  "customer": CustomerSection,
  "billing-address": BillingAddressSection,
  "shipping-address": ShippingAddressSection,
  "address-contact": GenericSection,
  "items": ItemsSection,
  "totals": TotalsSection,
  "discounts": DiscountsSection,
  "sales-team": SalesTeamSection,
  "currency-price-list": CurrencyPriceListSection,
  "shipping-fulfillment": GenericSection,
  "status-summary": StatusSummarySection,
  "commission": GenericSection,
  "more-info": GenericSection,
  "terms": GenericSection,
  "taxes_section": GenericSection,  // Tax template selection and taxes child table
  "shipping_section": GenericSection,  // Shipping rules and Incoterms
};

// Re-export types
export type { ShopifySectionWidgetProps } from './types';


